import React, { useEffect } from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";
import alumni_img from "../resources/images/download.jpeg";
import william from "../resources/images/william.jpg";
import miriam from "../resources/images/miriam.jpg";
import omani from "../resources/images/omani.jpg";
import felicia from "../resources/images/felicia.jpg";
import edem from "../resources/images/edem.jpg";
import AdmissionPic from "../resources/images/WhatsApp Image 2025-05-30 at 17.21.24_02b87b59.jpg";

import {
  FaFemale,
  FaSchool,
  FaUsers,
  FaBullseye,
  FaEye,
  FaHeart,
} from "react-icons/fa";
import { FaTrophy } from "react-icons/fa";

import AboutPic from "../resources/images/about.jpg";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="main">
      {/* <QuickContact/> */}
      <Navbar />
      <div className="content">
        <div className="content-header-container">
          <div className="bg-pattern"></div>

          <h2 className="content-name">About Us</h2>
        </div>
        <br />
        <div className="content-page-img">
          <img src={AdmissionPic} alt="" />
        </div>

        <div className="content-body admission-process">
          <p>
            At Star of the East School Complex, we are dedicated to fostering a
            nurturing and stimulating environment where students can thrive
            academically, socially, and emotionally. Our school, located in
            Taifa, Ghana, is committed to delivering a holistic education that
            emphasizes not only academic excellence but also character
            development and personal growth. With a team of passionate educators
            and staff, we work closely with parents to ensure every child’s
            potential is fully realized. At Star of the East, we believe in
            creating lifelong learners who are equipped to contribute positively
            to their communities and the world. Join us on a journey of
            discovery, innovation, and success!
          </p>
        </div>
        <br />
        <br />
        <h2 className="content-name info-section-header">Administration</h2>
        <div className="alumni-section">
          <div className="alumni-content">
            <div className="alumni-item">
              <img src={miriam} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> Mrs Miriam Hamilton <br />
                <strong>Position : </strong> Proprietor
              </div>
            </div>
            <div className="alumni-item">
              <img src={omani} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> Mr. Omani <br />
                <strong>Position : </strong> Headmaster
              </div>
            </div>
            <div className="alumni-item">
              <img src={felicia} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> Mrs Felicia
                <br />
                <strong>Position : </strong> Ass. Head Academics
              </div>
            </div>
            <div className="alumni-item">
              <img src={edem} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> Mr Edem <br />
                <strong>Position : </strong> Account / Bursar
              </div>
            </div>
            {/* <div className="alumni-item">
              <img src={william} alt="" />
              <div className="alumni-item-details">
                <strong>Name :</strong> William Etornam Goku <br />
                <strong>Position : </strong> Systems Administrator
              </div>
            </div> */}
          </div>
        </div>
        <br />
        <br />
        <br />
        <h2 className="content-name info-section-header">What We Stand For</h2>

        <div className="sch-mvc">
          <div className="mvc">
            <h2 className="content-named ">Our Mission</h2>
            <FaBullseye id="mvc-icon" />
            <p>
              To provide holistic, Christ-centered education that nurtures
              academic excellence, moral integrity, and spiritual growth,
              empowering students to become responsible and impactful citizens.
            </p>
            <br />
            <br />
          </div>
          <div className="mvc">
            <h2 className="content-named ">Vision</h2>
            <FaEye id="mvc-icon" />
            <p>
              To be a beacon of knowledge and character, raising future leaders
              who shine brightly in society and walk in victory through Christ.
            </p>
            <br />
            <br />
          </div>
          <div className="mvc">
            <h2 className="content-named ">Core Values</h2>
            <FaHeart id="mvc-icon" />
            <p>
              We uphold Faith in Christ as the foundation of all we do. We
              pursue Excellence in academics, behavior, and service. We value
              Integrity, promoting honesty and moral strength. We practice
              Discipline through self-control and respect.
            </p>
            <br />
            <br />
          </div>
        </div>

        <div className="sch-anthem">
          <h2 className="content-name info-section-header">School Anthem</h2>

          <p>
            <span>1</span>
            Brightest and best of the sons of the morning, Dawn on our darkness,
            and lend us your aid: Star of the East, the horizon adorning, Guide
            where our infant Redeemer is laid.
          </p>
          <br />
          <p>
            <span>2</span>
            Cold on his cradle the dew drops are shining; Low lies his head with
            the beasts of the stall; Angels adore him in slumber reclining,
            Maker, and Monarch, and Saviour of all.
          </p>
          <br />
          <p> <span>3</span>
            Brightest and best of the sons of the morning, Dawn on our darkness,
            and lend us your aid: Star of the East, the horizon adorning, Guide
            where our infant Redeemer is laid.
          </p>
          <br />
        </div>
        <br />
        <br />
        <br />
        <br />
        <div className="sch-m-stone">
          <h2 className="content-name info-section-header">Our Mile Stones</h2>
          <div className="m-stone">
            <div className="stone">
              {" "}
              <FaTrophy />{" "}
            </div>
            <div className="stone">
              <FaTrophy />
            </div>
            <div className="stone">
              <FaTrophy />
            </div>
            <div className="stone">
              <FaTrophy />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;
